module.exports = __webpack_public_path__ + "static/media/backgroundleftball.c08e78ed.svg";